import React, { useEffect, useRef } from 'react'
import VideoPlayer from '@sendspark/player'
import { Campaign } from '@sendspark/player/dist/types'
import { AnalyticsTracker, PlayerEvents } from '@sendspark/types'
import { VideoPlayerEvents } from '@sendspark/player/dist/VideoPlayer'

interface Props {
  campaign?: Campaign;
  analyticsTracker?: AnalyticsTracker;
  apiV2Url?: string;
  apiV1Url?: string;
  muxDataEnv?: string;
  muxDataDebug?: boolean;
  isEditPage?: boolean;
  events?: PlayerEvents;
  nodeEnv: string;
  autoPlay?: boolean;
  thumbsUp?: boolean;
  gapCombinedVideoPlayer?: boolean;
  replayVideo: boolean;
  setReplayVideo: (value: boolean) => void;
  embed?: boolean;
}

const Player = (props: Props) => {
  const { replayVideo, setReplayVideo } = props
  const ref = useRef<VideoPlayerEvents>(null)

  useEffect(() => {
    if (replayVideo) {
      ref.current?.watchAgainClick()
      setReplayVideo(false)
    }
  }, [replayVideo])

  return <VideoPlayer {...props} ref={ref} />
}

export default Player
